<script>
  'use strict'
</script>


<div class="maptilaz-icon" title="maptilaz 0.1">
  <svg xmlns="http://www.w3.org/2000/svg" style="isolation:isolate" viewBox="0 0 125 125" height="100%">
    <defs>
      <clipPath id="a">
        <path d="M0 0h125v125H0z"/>
      </clipPath>
    </defs>
    <g clip-path="url(#a)">
      <path fill="transparent" d="M0 0h125v125H0z"/>
      <path d="M0 50h25V25h25v25h25V25h25v25h25" fill="none" vector-effect="non-scaling-stroke" stroke-width="2" stroke="var(--section-color)" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="3"/>
      <path vector-effect="non-scaling-stroke" stroke-width="2" stroke="var(--section-color)" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="3" d="m75 25 50 50M75 50l50 50M25 25l50 50M25 50l25 25M0 50l25 25m75 25 25 25m-50-25 25 25"/>
      <path d="m25 100 25 25v-25H25V75h75v25H75v25" fill="none" vector-effect="non-scaling-stroke" stroke-width="2" stroke="var(--section-color)" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="3"/>
    </g>
  </svg>
</div>

<style>
  .maptilaz-icon {
    background: var(--font-color);
    height: 100%
  }	
</style>